import { useField } from "formik";

const BitacoraIrdmField = ({ label, placeholder, className, ...props }) => {
	const [field, , helpers] = useField(props);
	const hasValue = Boolean(field.value);

	return (
		<div className={`bitacora-irdm-field ${className || ''}`}>
			<label htmlFor={`field-${props.name}`}>{label}</label>
			<input
				{...field}
				{...props}
				id={`field-${props.name}`}
				className="bitacora-irdm-field__input"
				placeholder={placeholder}
			/>
			{hasValue &&
				<button
					type="button"
					className="bitacora-irdm-field__clear"
					onClick={() => helpers.setValue("")}
					aria-label={`Limpiar ${label}`}
				>
					<span aria-hidden="true"></span>
				</button>
			}
		</div>
	);
};

export default BitacoraIrdmField;
